export default __webpack_public_path__ + "static/media/notewrote1.6ee6d721.jpg";